import { ref, computed } from '@vue/composition-api';
import { intersection, difference } from 'lodash-es';
import { useLocationTargetingDataSource } from './index';
import { DISPLAY_NUMBER } from '../const';

export function useUndoCurrentChanges() {
  const { areaMap } = useLocationTargetingDataSource();

  /**
   * 上次选择的数据
   */
  const zipcodeIdsSnapShot = ref([]);
  const particleLocationsSnapShot = ref([]);
  const selectedIdsSnapShot = computed(() => [...zipcodeIdsSnapShot.value, ...particleLocationsSnapShot.value]);
  function setLastTimeSelected(opt: { zipcodeIds: number[]; particleLocations: number[] }): void {
    const { zipcodeIds, particleLocations } = opt;
    zipcodeIdsSnapShot.value = zipcodeIds;
    particleLocationsSnapShot.value = particleLocations;
  }

  /**
   * 当前手动选择的结果
   */
  const zipcodeIdsManual = ref([]);
  const particleLocationsManual = ref([]);
  const selectedIds = computed(() => [...zipcodeIdsManual.value, ...particleLocationsManual.value]);
  function setManualSelected(opt: { zipcodeIds: number[]; particleLocations: number[] }): void {
    const { zipcodeIds, particleLocations } = opt;
    zipcodeIdsManual.value = zipcodeIds;
    particleLocationsManual.value = particleLocations;
  }
  function updateManualSelected(opt: { zipcodeIds: number[]; particleLocations: number[] }): void {
    const { zipcodeIds, particleLocations } = opt;
    const isChangeByManual =
      [...zipcodeIdsManual.value, ...particleLocationsManual.value].join(',') ===
      [...zipcodeIds, ...particleLocations].join(',');
    if (!isChangeByManual) {
      setManualSelected({ zipcodeIds: [], particleLocations: [] });
    }
  }

  /**
   * 手动选择的和上次的对比
   */
  const commonSelectedIds = computed(() => intersection(selectedIdsSnapShot.value, selectedIds.value));
  // 被替换掉的
  const deletedLocationIds = computed(() => difference(selectedIdsSnapShot.value, commonSelectedIds.value));
  const deletedLocations = computed(() => {
    const totalCount = deletedLocationIds.value.length;
    return {
      totalCount,
      displayLocations: deletedLocationIds.value
        .slice(0, DISPLAY_NUMBER)
        .map(id => areaMap.value[id]?.translation)
        .join(', '),
      moreCount: totalCount - DISPLAY_NUMBER,
    };
  });
  // 替换后的
  const addedLocationIds = computed(() => difference(selectedIds.value, commonSelectedIds.value));
  const addedLocations = computed(() => {
    const totalCount = addedLocationIds.value.length;
    return {
      totalCount,
      displayLocations: addedLocationIds.value
        .slice(0, DISPLAY_NUMBER)
        .map(id => areaMap.value[id]?.translation)
        .join(', '),
      moreCount: totalCount - DISPLAY_NUMBER,
    };
  });

  /**
   * 是否出现提示
   * 存在删除并且新增的时候进行提示
   */
  const visibleCurrentChangeTip = computed(
    () => Boolean(deletedLocationIds.value.length) && Boolean(addedLocationIds.value.length),
  );

  return {
    setLastTimeSelected,
    setManualSelected,
    updateManualSelected,
    visibleCurrentChangeTip,
    deletedLocations,
    addedLocations,
    zipcodeIdsSnapShot,
    particleLocationsSnapShot,
  };
}
